import App from './components/App.svelte';

var app = new App({
	target: document.body
});

export default app;